interface ProjectNotificationsStore {
  clearNotifications(): void
}

interface ProjectNotificationsListStore {
  reset(): void
}

export function clearProjectNotifications(
  notificationsStore: ProjectNotificationsStore,
  notificationsListStore: ProjectNotificationsListStore,
): void {
  notificationsStore.clearNotifications()
  notificationsListStore.reset()
}
